import { useState, useEffect } from "react";
import { useAccount } from "wagmi";
import { supabase } from "@/integrations/supabase/client";
import type { Tables } from "@/integrations/supabase/types";

export function useCheckDAOMembership() {
  const { address } = useAccount();
  const [isDAOMember, setIsDAOMember] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [userDAOs, setUserDAOs] = useState<Tables<"daos">[]>([]);

  useEffect(() => {
    const checkMembership = async () => {
      if (!address) {
        setIsDAOMember(false);
        setUserDAOs([]);
        setIsLoading(false);
        return;
      }

      try {
        // Check if user has created any DAOs
        const { data, error } = await supabase
          .from("daos")
          .select("*")
          .eq("creator_address", address.toLowerCase())
          .is("archived_at", null);

        if (error) {
          console.error("Error checking DAO membership:", error);
          setIsDAOMember(false);
          setUserDAOs([]);
        } else {
          setIsDAOMember(data && data.length > 0);
          setUserDAOs(data || []);
        }
      } catch (error) {
        console.error("Error checking DAO membership:", error);
        setIsDAOMember(false);
        setUserDAOs([]);
      } finally {
        setIsLoading(false);
      }
    };

    checkMembership();
  }, [address]);

  return {
    isDAOMember,
    isLoading,
    userDAOs,
  };
}
